import { publishBoardSocketPackage } from '@walls/services/boardWebsockets';
import { wallsApi } from '@walls/services/wallsApi';
import {
  useWallContentStore,
  type CardId,
  type WallConnection,
  type WallId,
} from '@walls/store';

export function getConnectionsByCardId(connections: WallConnection[], cardId: CardId) {
  return connections.filter(
    (connection) => connection.start?.cardId === cardId || connection.end?.cardId === cardId
  );
}

export async function deleteConnectionsByCardId(
  boardId: WallId,
  cardId: CardId,
  topicKey?: string | null
) {
  const linkedConnections = getConnectionsByCardId(
    useWallContentStore.getState().connections,
    cardId
  );

  if (linkedConnections.length === 0) {
    return [];
  }

  useWallContentStore.getState().removeConnectionsByCardId(cardId);

  await Promise.all(
    linkedConnections.map((connection) => wallsApi.deleteConnection(boardId, connection.id, topicKey))
  );

  linkedConnections.forEach((connection) =>
    publishBoardSocketPackage({
      action: 'connectionDeleted',
      topic: boardId,
      connection: { id: connection.id },
    })
  );

  return linkedConnections;
}
